import FriendlyTime from "~/components/shared/FriendlyTime";
import UserAvatar from "~/components/shared/UserAvatar";
import Emojify from "~/components/shared/Emojify";

export type PausedAgent = {
  name: string;
  pausedAt: string;
  pausedBy: {
    name: string;
    avatar: {
      url: string;
    };
  };
  pausedNote?: string | null;
  pausedTimeoutInMinutes: number;
};

function PausedAgentNote({ note }: { note?: string | null }) {
  if (note == null || note.length === 0) {
    return null;
  }

  return (
    <div className="mb-5 mt-2">
      <p className="px5 depth rounded-1.5 charcoal-800 m-0 inline-block bg-white py-5">
        <Emojify text={note} />
      </p>
    </div>
  );
}

function PausedAgentDetails({ agent }: { agent: PausedAgent }) {
  return (
    <div className="charcoal-500 border-gray-400" role="listitem">
      <div className="gap2 flex">
        {agent.pausedBy && (
          <span className="gap1 flex items-center">
            <UserAvatar user={agent.pausedBy} size="MICRO" />
            {agent.pausedBy.name}
          </span>
        )}
        <span className="parsnip-400">&bull;</span>
        <FriendlyTime value={agent.pausedAt} capitalized={true} />
        <span className="parsnip-400">&bull;</span>
        <em>Automatically resumes after {agent.pausedTimeoutInMinutes} minutes</em>
      </div>
      <PausedAgentNote note={agent.pausedNote} />
    </div>
  );
}

export default function PausedAgentNotice({ agent }: { agent: PausedAgent }) {
  if (!agent) {
    return null;
  }

  return (
    <div className="p6 rounded-1.5 border-parsnip-400 bg-parsnip-100 mb-2 border pb-0 antialiased">
      <h2 className="charcoal-900 m-0 mb-3" style={{ fontSize: 16 }}>
        Agent Paused
      </h2>

      <div className="mb-6" role="list">
        <PausedAgentDetails key={agent.name} agent={agent} />
      </div>
    </div>
  );
}
